"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceDocumentation = void 0;
const metadata_1 = require("./metadata");
const ref_1 = require("./ref");
const SchemaResolver_1 = require("./SchemaResolver");
class ServiceDocumentation {
    resolver = new SchemaResolver_1.SchemaResolver({
        refPrefix: '#/components/schemas',
    });
    getDescription(extras = '') {
        const deployedBranch = process.env.CI_COMMIT_BRANCH || 'n/a';
        const deployedCommit = process.env.CI_COMMIT_SHORT_SHA || 'n/a';
        return [
            extras,
            `<p><b>Branch:</b> ${deployedBranch}</p>`,
            `<p><b>Commit:</b> ${deployedCommit}</p>`,
        ].join('\n');
    }
    getDefaultServer(domain, basePath) {
        if (!basePath) {
            return {
                url: `https://${domain}`,
            };
        }
        else {
            return {
                url: `https://${domain}/${basePath}`,
            };
        }
    }
    getSchemas() {
        return this.resolver.getSchemas();
    }
    getDocumentationFor(handlerClass, method) {
        const operation = metadata_1.metadata.operation
            .get(handlerClass.prototype)
            ?.get(method);
        if (!operation) {
            throw new Error(`No @Operation metadata registered for ${handlerClass.name}.${method}`);
        }
        const openApiOperation = {
            summary: operation.summary,
            description: operation.description,
            tags: operation.tags,
            parameters: [
                ...this.createParameters('path', operation.path),
                ...this.createParameters('query', operation.query),
            ],
            requestBody: operation.body
                ? {
                    content: {
                        'application/json': {
                            schema: typeof operation.body === 'function'
                                ? (0, ref_1.ref)(operation.body)
                                : operation.body,
                        },
                    },
                }
                : undefined,
            responses: operation.responses || {},
        };
        return this.resolver.substituteMagicRefs(openApiOperation);
    }
    createParameters(location, params) {
        if (typeof params !== 'function') {
            return Object.entries(params || {}).map(([name, data]) => ({
                name,
                in: location,
                ...data,
            }));
        }
        else {
            const paramsClass = params();
            const paramsSchema = this.resolver.generateSchemaForModel(paramsClass);
            const required = paramsSchema.required || [];
            const { parameters: paramsMetadata } = this.resolver.getMetadataRecursively(paramsClass);
            return Object.entries(paramsSchema.properties || {}).map(([name, schema]) => ({
                ...paramsMetadata.get(name),
                name,
                in: location,
                required: required.includes(name),
                schema,
            }));
        }
    }
}
exports.ServiceDocumentation = ServiceDocumentation;
